const { Button } = window.Material;

interface ButtonProps {
  className?: string;
  variant?: string;
  color?: any;
  label?: string;
  href?: string;
  onClick?: () => void;
  primary?: boolean;
  disabled?: boolean | any;
  children?: any;
  id?: string;
  type?: string;
  fullWidth?: boolean;
}

export default class EdocatButton extends window.React.PureComponent<ButtonProps, {}> {
  static defaultProps: ButtonProps = {
    className: '',
    fullWidth: false,
    type: 'button',
  };

  render() {
    const {
      className,
      fullWidth,
      label,
      href,
      onClick,
      primary,
      disabled,
      variant,
      children,
      id,
      color,
      type,
    } = this.props;
    const finalVariant = variant ? variant : primary ? 'contained' : 'outlined';
    const finalColor = primary ? 'primary' : color;
    if (children?.type === 'button') {
      const props = children.props;
      const type = onClick || props?.onClick ? '' : 'submit';
      // @ts-ignore
      return (
        <Button
          className={className}
          type={type}
          fullWidth={fullWidth}
          variant={finalVariant}
          color={finalColor}
          disabled={disabled ? !!disabled : !!props?.disabled}
          href={href}
          onClick={onClick ? onClick : props?.onClick}
          id={id}
        >
          <span className="first-child">
            <span>
              {label && label}
              {!label && props?.children}
            </span>
          </span>
        </Button>
      );
    } else {
      // @ts-ignore
      return (
        <Button
          id={id}
          type={type}
          className={className}
          fullWidth={fullWidth}
          variant={finalVariant}
          color={finalColor}
          disabled={!!disabled}
          href={href}
          onClick={onClick}
        >
          <span className="first-child">
            {label && <span>{label}</span>}
            {!label && this.props.children}
          </span>
        </Button>
      );
    }
  }
}
